export default __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/chemistry-80c719162ed97b19791f187e2fafb5fa.svg";